(() => {
  const EVENT_NAME = 'bathwise:conversion';

  const publishToShopifyAnalytics = (eventName, payload) => {
    const analytics = window.Shopify?.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;

    const publication = analytics.publish(`bathwise:${eventName}`, payload);
    if (publication && typeof publication.catch === 'function') {
      publication.catch(() => {});
    }
  };

  const publishConversion = (eventName, detail) => {
    const payload = {
      source: 'bathwise',
      path: detail.path || window.location.pathname,
      label: detail.label || '',
      href: detail.href || ''
    };

    // Keep Bathwise custom conversion delivery on Shopify's customer-event
    // system instead of sending directly to third-party tracker globals.
    // Pixel/consent behaviour must still be verified in the rendered store.
    publishToShopifyAnalytics(eventName, payload);
  };

  const emit = (eventName, detail = {}) => {
    if (!eventName) return;
    const eventDetail = {
      event: eventName,
      path: window.location.pathname,
      ...detail
    };

    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: eventDetail }));
    publishConversion(eventName, eventDetail);
  };

  const classifyLink = (link) => {
    const href = link.getAttribute('href') || '';
    if (link.classList.contains('bw-product-enquiry')) return 'product_enquiry_click';
    if (href.startsWith('/pages/appointments')) return 'appointment_cta_click';
    if (href.startsWith('/pages/our-showroom-gallery')) return 'showroom_cta_click';
    if (href.startsWith('/pages/contact')) return 'contact_cta_click';
    return '';
  };

  document.addEventListener('DOMContentLoaded', () => {
    const appointmentForm = document.getElementById('bw-appointment-form');
    if (appointmentForm) {
      appointmentForm.addEventListener('submit', () => {
        emit('appointment_request_submit_intent', { label: 'appointments_page' });
      });
    }
    if (document.querySelector('.bw-appointment__success')) {
      emit('appointment_request_success', { label: 'appointments_page' });
    }

    const contactForm = document.getElementById('bw-contact-form');
    if (contactForm) {
      contactForm.addEventListener('submit', () => {
        emit('contact_enquiry_submit_intent', { label: 'contact_page' });
      });
    }
    if (document.querySelector('.bw-contact__success')) {
      emit('contact_enquiry_success', { label: 'contact_page' });
    }

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('.bw-product-form .bw-add[type="submit"]');
      if (addButton && !addButton.disabled) {
        const productTitle = document.querySelector('.bw-product-page__info h1')?.textContent?.trim() || '';
        emit('product_add_to_basket_click', { label: productTitle });
        return;
      }

      const link = event.target.closest('a[href]');
      if (!link) return;
      const conversion = classifyLink(link);
      if (!conversion) return;
      emit(conversion, {
        label: link.textContent.trim().slice(0, 80),
        href: link.getAttribute('href') || ''
      });
    });
  });
})();
